"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.buildTaggingInfo = exports.MARGIN = exports.OPACITY = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _gerenciatdUnifiedicons = _interopRequireWildcard(require("@bit/gerenciatd.unifiedicons.cheuron"));

var _gerenciatdUnifiedcomponents = _interopRequireDefault(require("@bit/gerenciatd.unifiedcomponents.custom-link"));

require("./Arrow.scss");

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const DIRECTION = {
  LEFT: 'LEFT',
  RIGHT: 'RIGHT'
};
const SIZE = {
  BIG: 'big',
  SMALL: 'small'
};
const OPACITY = {
  OP_1: 'op-1',
  OP_0_6: 'op-0-6'
};
exports.OPACITY = OPACITY;
const MARGIN = {
  NONE: 'none',
  DEFAULT: 'default'
};
exports.MARGIN = MARGIN;

const buildTaggingInfo = (index, taggingInfo, eventType = 'click', way = 'left') => {
  return _objectSpread(_objectSpread({}, taggingInfo), {}, {
    eventType,
    componentContent: way.toLowerCase() === 'left' ? `Ir-Atras-${index - 1}` : `Ir-Adelante-${index + 1}`,
    debug: true
  });
};

exports.buildTaggingInfo = buildTaggingInfo;

const Arrow = ({
  page2go,
  kind,
  taggingInfo,
  onClick,
  iconProps,
  visible,
  size,
  opacity,
  bgColor,
  margin
}) => {
  const currentTaggingInfo = buildTaggingInfo(page2go, taggingInfo, 'click', kind);
  const cssBase = `arrow arrow_bgColor--${bgColor} arrow-${kind.toLowerCase()}--margin-${margin} arrow--${size} arrow_opacity--${opacity}`;
  const cssVisible = visible ? ` ${cssBase} visible` : ` ${cssBase} hidden`;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents.default, {
    className: `${cssBase}${cssVisible}`,
    onClick: visible ? onClick : () => {},
    taggingInfo: currentTaggingInfo,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedicons.default, _objectSpread({}, iconProps))
  });
};

Arrow.propTypes = {
  iconProps: _propTypes.default.shape({
    id: _propTypes.default.string,
    kind: _propTypes.default.string,
    color: _propTypes.default.string,
    size: _propTypes.default.number
  }),

  /**
   * {
   *  "info": "Indica el numero de la slide, producto o cosa a la que se va a desplazar",
   *  "kind": "both",
   *  "beautifulName": "Indice numérico del destino"
   * }
   */
  page2go: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]).isRequired,

  /**
   * {
   *  "info": "Indica el sentido del cheuron",
   *  "kind": "both",
   *  "beautifulName": "Dirección cheuron"
   * }
   */
  kind: _propTypes.default.oneOf([DIRECTION.LEFT, DIRECTION.RIGHT]),

  /**
   * {
   *  "info": "Información de tagueo",
   *  "kind": "both",
   *  "beautifulName": "Tagueo"
   * }
   */
  taggingInfo: _propTypes.default.object.isRequired,

  /**
   * {
   *  "info": "Función que se ejecutará al hacer click",
   *  "kind": "both",
   *  "beautifulName": "onClick"
   * }
   */
  onClick: _propTypes.default.func.isRequired,

  /**
   * {
   *  "info": "Permite ocultar o mostrar el elemento",
   *  "kind": "both",
   *  "beautifulName": "visible"
   * }
   */
  visible: _propTypes.default.bool,

  /**
   * {
   *  "info": "Indica el tamaño del círculo que engloba el cheuron",
   *  "kind": "both",
   *  "beautifulName": "size"
   * }
   */
  size: _propTypes.default.string,

  /**
   * {
   *  "info": "Indica la opacidad del círculo que engloba el cheuron",
   *  "kind": "both",
   *  "beautifulName": "size"
   * }
   */
  opacity: _propTypes.default.oneOf([OPACITY.OP_0_6, OPACITY.OP_1]),

  /**
   * {
   *  "info": "Indica el margin del arrow, por defecto está a none",
   *  "kind": "both",
   *  "beautifulName": "size"
   * }
   */
  margin: _propTypes.default.oneOf([MARGIN.NONE, MARGIN.DEFAULT])
};
Arrow.defaultProps = {
  kind: _gerenciatdUnifiedicons.CHEURON_TYPES.LEFT,
  visible: true,
  iconProps: {
    id: 'CircleCheuron',
    kind: DIRECTION.LEFT,
    color: 'black',
    size: 40
  },
  size: SIZE.BIG,
  opacity: OPACITY.OP_1,
  margin: MARGIN.NONE
};
var _default = Arrow;
exports.default = _default;

//# sourceMappingURL=index.js.map